import { useForm } from 'react-hook-form'
import { FormObjectType, GiftSendFormItemsType } from 'src/types/react-hook-form'
import { HyphenReplace, NumReplace, regExps } from 'src/utils/regExps_util'
import { GiftSendType } from 'src/types/api'

const useGiftSendForm = () => {
  const methods = useForm<GiftSendFormItemsType>({
    mode: 'onBlur',
    defaultValues: {
      sendType: 0,
      cardIdx: 0,
      msg: '',
      recipientPNumber: '',
    },
  })
  const { setValue, watch } = methods

  const pNumberOnChangeHandler = (event: { target: { value: string } }) => {
    setValue('recipientPNumber', NumReplace(event.target.value, 11), { shouldValidate: true })

    if (regExps.numReg.pattern.test(event.target.value) && event.target.value.length === 11)
      setValue('recipientPNumber', HyphenReplace(event.target.value))
  }

  const messageOnChangeHandler = (event: { target: { value: string } }) => {
    const regCantUseChar =
      /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9\s.,!?'"“”‘’()\[\]{}\-_/\\:;@#$%^&*+=<>|~`♥♡★☆]/gu
    setValue('msg', event.target.value?.replace(regCantUseChar, '').slice(0, 100), {
      shouldValidate: true,
    })
  }

  const getRegisterAttribute = (
    sendType: GiftSendType,
  ): Partial<Record<keyof GiftSendFormItemsType, Partial<FormObjectType>>> => ({
    sendType: {
      tag: 'sendType',
      optionValueList: [
        { value: 0, text: 'KAKAOTALK' },
        { value: 1, text: 'SMS' },
      ],
    },
    cardIdx: {
      tag: 'cardIdx',
      register_options: {
        inputmode: 'numeric',
      },
    },
    msg: {
      type: 'text',
      tag: 'msg',
      register_options: {
        onChange: messageOnChangeHandler,
        maxLength: 100,
      },
    },
    ...(sendType === 1 && {
      recipientPNumber: {
        placeholder: '휴대폰 번호 입력',
        type: 'tel',
        tag: 'recipientPNumber',
        register_options: {
          required: '받는 분의 휴대폰 번호를 입력해주세요.',
          minLength: { value: 11, message: '받는 분의 휴대폰 번호를 정확히 입력해주세요.' },
          pattern: {
            value: /^010[-0-9]*$/,
            message: '받는 분의 휴대폰 번호를 정확히 입력해주세요.',
          },
          onChange: pNumberOnChangeHandler,
          inputmode: 'numeric',
        },
      },
    }),
  })

  const registerAttribute = getRegisterAttribute(watch('sendType'))

  return {
    methods,
    registerAttribute,
  }
}
export default useGiftSendForm
